<section class="session-toggle-form session-activity" [ngClass]="{ active: isAddSessionSliderOpen}">
  <div class="sessionFormWrap">
    <div class="Header">
      <h2>
        <b>{{sessionSliderHeader}}</b>
      </h2>
      <p-button appPreventDoubleClick styleClass="p-button-text" id="sessionSliderCloseButton" type="button" label="Close"
        (debounceClick)="closeSlider()"></p-button>
    </div>

    <div *ngIf="errorMessages.length > 0" class="sessionSliderErrorMessagePlaceHolder">
      <p-messages severity="error">
        <ng-template pTemplate>
          <div class="p-message-wrapper">
            <div>
              <span class="p-message-icon pi pi-times-circle"></span>
              <span class="p-ml-2">{{ errorMessageHeaderText }}</span>
            </div>
            <div>
              <ul>
                <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
              </ul>
            </div>
          </div>
        </ng-template>
      </p-messages>
    </div>
    <form [formGroup]="sessionForm">
      <div class="general-tab">
        <div class="fields-row">
          <div class="field field-required">
            <bpt-datetime id="sessionStartDateTime" label="Start Date and Time" [includeTime]=true
              formControlName="startDateTime" [required]="true"
              [ngClass]="{ 'error-highlight': mandatoryFields['startDateTime'] }"></bpt-datetime>

          </div>
          <div class="field field-required">
            <bpt-datetime id="sessionEndDateTime" label="End Date and Time" [includeTime]=true
              formControlName="endDateTime" [required]="true"
              [ngClass]="{ 'error-highlight': mandatoryFields['endDateTime'] }"></bpt-datetime>
          </div>
          <div class="field field-required">
            <bpt-dropdown label="Time Zone" id="timeZone" formControlName="timeZone"
              [options]="sessionBindData.timeZones" [valueField]="valueField" [labelField]="labelField"
              [editable]="false" [showClear]="true" [showFilter]="true" [required]="true"
              [ngClass]="{ 'error-highlight': mandatoryFields.timeZone }">
            </bpt-dropdown>
          </div>
        </div>
        <div class="fields-row">
          <div class="field field-required">
            <bpt-dropdown label="Enrollment" [options]="sessionBindData.enrollments" [editable]="false"
              formControlName="enrollment" id="enrollment" [valueField]="valueField" [labelField]="labelField"
              [showClear]="true" [showFilter]="true" [required]="true"
              [ngClass]="{ 'error-highlight': mandatoryFields.enrollment }">
            </bpt-dropdown>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
        <div class="fields-row">
          <div class="field field-required">
            <bpt-dropdown label="Internal Trainer(s)" [options]="usersAndAssignmentGroupList" [valueField]="valueField"
              [labelField]="labelField" [multiSelect]="true" [editable]="false" formControlName="InternalTrainers"
              id="internalTrainers" [showClear]="true"
              [ngClass]="{ 'error-highlight': mandatoryFields.InternalTrainers}" [showFilter]="true">
            </bpt-dropdown>
          </div>
          <div class="field">
            <bpt-text-input formControlName="externalTrainers" [highlightAllOnFocus]="true" id="externalTrainers"
              label="Other Trainer(s)"
              [ngClass]="{ 'error-highlight': mandatoryFields.externalTrainers}"></bpt-text-input>
          </div>
        </div>
        <div class="fields-row">
          <div class="field field-required">
            <bpt-dropdown label="Format" [options]="sessionBindData.formats" [editable]="false"
              formControlName="sessionFormat" id="format" [showClear]="true" [showFilter]="true"
              [valueField]="valueField" [labelField]="labelField"
              [ngClass]="{ 'error-highlight': mandatoryFields.format }" [required]="true">
            </bpt-dropdown>
          </div>
          <div class="field">
            <bpt-text-input formControlName="room" [highlightAllOnFocus]="true" id="room" label="Room"
              [required]="ifFormatIsVirtual" [ngClass]="{ 'error-highlight': mandatoryFields.room}"></bpt-text-input>
          </div>
          <div class="field">
            <bpt-text-input formControlName="virtualMeetingURL" [highlightAllOnFocus]="true" id="virtualMeetingURL"
              label="Virtual Meeting URL" [required]="ifFormatIsInPerson"
              [ngClass]="{ 'error-highlight': mandatoryFields.virtualMeetingURL}"></bpt-text-input>
          </div>
        </div>

        <div class="fields-row">
          <div class="col-4" *ngIf="fileUploadedEnabled">
            <bpt-file-upload [uploadFiles]="uploadSucceeds" [deleteFile]="deleteFile" [maxSize]="maxFileSize"
              [fileNames]="savedFiles" [fileTypes]="''"></bpt-file-upload>
          </div>
        </div>
        <div class="button">
          <p-button appPreventDoubleClick label="Save" type="submit" id="saveSession" class="align-right" styleClass="bpt-button-compact"
            (debounceClick)="saveSession()">
          </p-button>
        </div>
      </div>
    </form>
  </div>
  <app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField"
    (confirmed)="saveSessionWithInactiveAssignmentGroup()" (dialogClosed)="closeConfirmationDailog($event)">
  </app-confirmation-dialog>
</section>
<p-dialog [(visible)]="showDeletedFilesConfirmationModal" [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()" [modal]="true">
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ deleteAttachmentConfirmationMessage }}</span>
  </div>
  <ul>
    <li *ngFor="let deleteAttachment of deletedAttachmentsForConfirmation">
      {{ deleteAttachment.attachmentName }}
    </li>
  </ul>
  <ng-template pTemplate="footer">
    <p-button appPreventDoubleClick label="No" type="submit" icon="pi pi-times" id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined" class="align-right" (debounceClick)="closeConfirmationModal()">
    </p-button>
    <p-button appPreventDoubleClick label="Yes" icon="pi pi-check" type="submit" id="deletedFilesConfirmationYesButton" class="align-right"
      (debounceClick)="updateSession()">
    </p-button>
    
  </ng-template>
</p-dialog>
